// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'csr-connected';

export const Component = () => (
  <g fill='currentColor'>
    <path d='M5.598 8.703a.5.5 0 0 1 .699-.105c1.185.874 1.953 2.298 1.953 3.902s-.768 3.028-1.953 3.902a.5.5 0 1 1-.594-.804c.935-.69 1.547-1.819 1.547-3.098s-.612-2.408-1.547-3.098a.5.5 0 0 1-.105-.699zm3.498-3.997a.5.5 0 0 1 .698-.11A9.756 9.756 0 0 1 13.8 12.5a9.756 9.756 0 0 1-4.006 7.904.5.5 0 0 1-.588-.808C11.382 18.01 12.8 15.424 12.8 12.5s-1.418-5.51-3.594-7.096a.5.5 0 0 1-.11-.698z' />
    <path d='M13.805 1.694a.5.5 0 0 1 .701-.09C17.658 4.048 19.7 8.024 19.7 12.5c0 4.477-2.042 8.453-5.194 10.895a.5.5 0 1 1-.612-.79c2.904-2.25 4.806-5.933 4.806-10.105s-1.902-7.854-4.806-10.105a.5.5 0 0 1-.09-.701z' />
  </g>
);

export const viewBox = '0 0 25 25';
